import React from "react";
import styled from '@emotion/styled';

const Container = styled.div`
  border: ${({ selected }) =>
    selected ? '2px solid #3B72FE' : '1px solid #ddd'};
  border-radius: 12px;
  padding: 15px;
  transition: border 0.2s;
`;

const AddressText = styled.p`
  font-size: 14px;
`;

const AddressBox = ({ addressObject, children, selected }) => {
  return (
    <Container selected={selected}>
      <h4 style={{ fontSize: 14 }}>
        {addressObject.address_name}
      </h4>
      <AddressText>
        {addressObject.address
          .split(",")
          .filter((part) => part.trim() !== "United States")
          .map((part, index) => (
            <AddressText key={index}>{part.trim()}</AddressText>
          ))}
      </AddressText>
      <AddressText>{addressObject.address_optional}</AddressText>
      {children}
    </Container>
  );
};

export default AddressBox;